<template>
    <div>
        <!-- TODO: Handle disabled state -->
        <FormControl
            label="Type"
            required
            :error="
                errors.getValidationError(
                    RequestBodyKeyEnum.App_UpdateService_CustomFields_Type,
                )
            "
        >
            <div class="space-y-2">
                <RadioInput
                    :disabled="customField"
                    :checked="customField?.type === CustomFieldTypeEnum.Text"
                    label="Text"
                    :value="CustomFieldTypeEnum.Text"
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_Type
                    "
                    v-model="dummySelectedType"
                    required
                />
                <RadioInput
                    :disabled="customField"
                    :checked="
                        customField?.type === CustomFieldTypeEnum.RadioSelect
                    "
                    label="Radio/Select"
                    :value="CustomFieldTypeEnum.RadioSelect"
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_Type
                    "
                    v-model="dummySelectedType"
                    required
                />
                <RadioInput
                    :disabled="customField"
                    :checked="customField?.type === CustomFieldTypeEnum.Number"
                    label="Number"
                    :value="CustomFieldTypeEnum.Number"
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_Type
                    "
                    v-model="dummySelectedType"
                    required
                />
                <RadioInput
                    :disabled="customField"
                    :checked="
                        customField?.type === CustomFieldTypeEnum.SingleCheckbox
                    "
                    label="Single Checkbox"
                    :value="CustomFieldTypeEnum.SingleCheckbox"
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_Type
                    "
                    v-model="dummySelectedType"
                    required
                />
                <RadioInput
                    :disabled="customField"
                    :checked="
                        customField?.type ===
                        CustomFieldTypeEnum.MultipleCheckbox
                    "
                    label="Multiple Checkbox"
                    :value="CustomFieldTypeEnum.MultipleCheckbox"
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_Type
                    "
                    v-model="dummySelectedType"
                    required
                />
            </div>
        </FormControl>

        <template v-if="dummySelectedType">
            <FormControl
                label="Required"
                required
                :error="
                    errors.getValidationError(
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_IsRequired,
                    )
                "
            >
                <div class="space-y-1">
                    <RadioInput
                        label="Yes"
                        value="1"
                        :name="
                            RequestBodyKeyEnum.App_UpdateService_CustomFields_IsRequired
                        "
                        :checked="
                            customField?.isRequired === true ? true : undefined
                        "
                        required
                    />
                    <RadioInput
                        label="No"
                        value="0"
                        :name="
                            RequestBodyKeyEnum.App_UpdateService_CustomFields_IsRequired
                        "
                        :checked="
                            customField?.isRequired === false ? true : undefined
                        "
                        required
                    />
                </div>
            </FormControl>
            <FormControl
                label="Internal name (not visible to your customers)"
                required
                :error="
                    errors.getValidationError(
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_InternalName,
                    )
                "
            >
                <TextInput
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_InternalName
                    "
                    :value="customField?.internalName"
                    required
                />
            </FormControl>
            <FormControl
                label="Title"
                required
                :error="
                    errors.getValidationError(
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_IsRequired,
                    )
                "
            >
                <TextInput
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_Title
                    "
                    :value="customField?.title"
                    required
                />
            </FormControl>
            <!-- <FormControl label="Description">
                <TextInput
                    name="description"
                    :value="customField?.description"
                />
            </FormControl> -->
            <input
                type="hidden"
                :name="
                    RequestBodyKeyEnum.App_UpdateService_CustomFields_Description
                "
            />
            <FormControl
                label="Enabled"
                required
                :error="
                    errors.getValidationError(
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_IsEnabled,
                    )
                "
            >
                <CheckboxInput
                    :name="
                        RequestBodyKeyEnum.App_UpdateService_CustomFields_IsEnabled
                    "
                    label="Is enabled"
                    :checked="customField ? customField.isEnabled : true"
                />
            </FormControl>
        </template>

        <template v-if="dummySelectedType === CustomFieldTypeEnum.Text">
            <CustomFieldFormText
                :customField="customField"
                :errors="errors"
            />
        </template>
        <template
            v-else-if="dummySelectedType === CustomFieldTypeEnum.RadioSelect"
        >
            <CustomFieldFormRadioSelect
                :customField="customField"
                :errors="errors"
            />
        </template>
        <template v-else-if="dummySelectedType === CustomFieldTypeEnum.Number">
            <CustomFieldFormNumber
                :customField="customField"
                :errors="errors"
            />
        </template>
        <template
            v-else-if="dummySelectedType === CustomFieldTypeEnum.SingleCheckbox"
        >
            <CustomFieldFormSingleCheckbox
                :customField="customField"
                :errors="errors"
            />
        </template>
        <template
            v-else-if="
                dummySelectedType === CustomFieldTypeEnum.MultipleCheckbox
            "
        >
            <CustomFieldFormMultipleCheckbox
                :customField="customField"
                :errors="errors"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import { CustomFieldTypeEnum } from '@/Shared/AutoGenerated/Main'

    import CustomField from '@/App/CustomField/Entity/CustomField'

    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import RadioInput from '@/Shared/Component/Forms/RadioInput.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'

    import CustomFieldFormText from '@/App/CustomField/Component/CustomFieldFormText.vue'
    import CustomFieldFormRadioSelect from '@/App/CustomField/Component/CustomFieldFormRadioSelect.vue'
    import CustomFieldFormNumber from '@/App/CustomField/Component/CustomFieldFormNumber.vue'
    import CustomFieldFormSingleCheckbox from '@/App/CustomField/Component/CustomFieldFormSingleCheckbox.vue'
    import CustomFieldFormMultipleCheckbox from '@/App/CustomField/Component/CustomFieldFormMultipleCheckbox.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField | null>,
            default: null,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const dummySelectedType = ref<CustomFieldTypeEnum | null>(
        props.customField?.type ?? null,
    )
</script>
